<template>
  <div>
    <CRow>
      <CCol md="12">
          <CCard>
            <CCardHeader>
              <CRow>
                <CCol col="6">
                  <strong>لیست پرسنل</strong>

                </CCol>
                <CCol col="6">
                  <CButton outlined primary size="sm" color="primary"
                  @click="$router.push({path:'add'})"
                  >پرسنل جدید</CButton>
                </CCol>
              </CRow>
            </CCardHeader>
            <CCardBody>
              <CDataTable
                  :items="items"
                  :fields="fields"
                  @row-clicked="table_row_clicked"

                  :items-per-page="10"
                  hover
                  sorter
                  striped
                  border
                  column-filter
                  pagination
              >
                <template #row="{item,index}">
                  <td style="text-align: center">
                    <p >{{ index + 1 }}</p>
                  </td>
                </template>
                <template #insurance="{item}">
                  <td style="text-align: center">
                    <p v-if="item.insurance==0">بیمه ندارد</p>
                    <p v-if="item.insurance==1">بیمه دارد</p>
                  </td>
                </template>

                <template #operation="{item}">
                  <td>
                    <!--                            <CIcon @click.native="goSubCategories(item)" class="mr-1 text-success"-->
                    <!--                                   name="cilApplications"/>-->

                    <CIcon @click.native="$router.push({path:'edit/'+item.id})" class=" mr-1 text-primary" name="cil-pencil"/>

<!--                    <CIcon @click.native="delete_item_dialog(item)" class="mr-1 text-danger" name="cilTrash"/>-->

                  </td>
                </template>


              </CDataTable>
            </CCardBody>

          </CCard>
      </CCol>
    </CRow>

  </div>
</template>

<script>
import axios from "axios";
import {bus} from '../../../main';

var items = [];


export default {
  name: 'Login',
  data() {
    return {
      confirm_delete_name: "confirm_brand" + new Date().getTime() + "_" + this.$vnode.tag,

      items: [],

      fields: [
        {key: 'row', label: this.$t('tables.row'),sorter:false, _style: 'width:10%'},
        {key: 'first_name', label: "نام", _style: 'width:20%'},
        {key: 'last_name', label: "نام خانوادگی", _style: 'width:20%;'},
        {key: 'mobile', label:"موبایل", _style: 'width:20%;'},
        {key: 'national_code', label: "کد ملی", _style: 'width:20%;'},
        {key: 'present_id', label: "شناسه دستگاه", _style: 'width:20%;'},
        {key: 'insurance', label: "وضعیت بیمه", _style: 'width:20%;'},
        {key: 'operation', label: "", filter: false, _style: 'width:10%;'},
      ],
      collapseDuration: 0,
      status_form: 0
    }
  }, mounted() {
    this.$root.root_validate_errors = [];

    this.get_lists();
    bus.$on(this.confirm_delete_name, (data) => {
      // alert(data);
      if (data == "true") {
        this.delete_item();

      } else {
        this.status_form = 0;
      }
    });
  }, watch: {
    '$route.params.cat_id': function () {
      this.get_lists();
    }
  },
  methods: {
    table_row_clicked(item, index) {

      this.table_clicks++;
      if (this.table_clicks == 1) {
        this.table_clicks_timer = setTimeout(() => {
          // this.result.push(event.type);
          this.table_clicks = 0
        }, 500);
      } else if (this.table_clicks > 1) {
        clearTimeout(this.table_clicks_timer);
        this.edit_item(item)
        this.table_clicks = 0

      }

    },

    get_lists() {
      var self = this;
      console.log("route id " + this.$route.params.cat_id);

      const formData = new FormData();


      // formData.append('id', this.selected_province);


      axios.post('/get_personnels',formData, {
        params: {
          // isparent : self.$route.params.cat_id
        },

      }).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
          self.items = content_data.map((item, row_id) => {
            return {...item, row_id}
          });


      })
          .catch(function (error) {

            console.log(error);
          });

    },
    delete_item_dialog(item) {
      this.$root.modal_component.show_confirm_modal(this.$t("dialogs.warning"), this.$t("dialogs.deleteMessage"), [this.$t("dialogs.ok")], this.confirm_delete_name);

      this.status_form = this.items[item.row_id].id;

    },
    delete_item() {


      let self = this;
      const formData = new FormData()
      let url;
      url = "DeleteBrand";


      formData.append('id', this.status_form);

      axios.post(url, formData, {}).then((res) => {

        self.$root.modal_component.show_api_response_modals(res);

        self.status_form = 0;

        self.get_lists();


      })
          .catch(function (error) {

            console.log(error);
          });
// this.get_categories();
      // this.$router.push({ path: '/posts/'});
    },
  }
}

</script>
